import { Link } from 'react-router-dom';
import { hotComics } from '@/mocks/comics';

export default function FeaturedComics() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-display font-bold text-foreground-900">
              <i className="ri-fire-line text-accent-500 mr-2"></i>
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">千万读者都在追的韩国漫画</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300"
              data-product-shop
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {comic.status === '连载中' && (
                  <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-full font-medium">
                    {comic.status}
                  </span>
                )}
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-10">
                  <div className="flex items-center gap-1 text-background-50 text-xs">
                    <i className="ri-star-fill text-yellow-400 text-xs"></i>
                    <span>{comic.rating}</span>
                  </div>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                <div className="flex items-center gap-2 mt-2 flex-wrap">
                  {comic.categories.slice(0, 2).map((cat) => (
                    <span
                      key={cat}
                      className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700"
                    >
                      {cat === 'romance' ? '恋爱' : cat === 'fantasy' ? '奇幻' : cat === 'action' ? '动作' : cat === 'comedy' ? '搞笑' : cat === 'thriller' ? '悬疑' : cat === 'drama' ? '剧情' : cat === 'daily' ? '日常' : cat === 'school' ? '校园' : '职场'}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}